export default __webpack_public_path__ + "static/media/FullLogo.cadf503a.svg";